import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import Bin from "../common/Bin";

const LinkedTable = ({ parameters, handleDelete }) => {
  return (
    <table className="table">
      <caption style={{ captionSide: "top", paddingBottom: 0 }}>
        {parameters.length} Parameters
      </caption>
      <thead>
        <tr>
          <th>Parameter</th>
          <th>Label</th>
          <th>Type</th>
          <th>Last Updated</th>
          <th>Updated By</th>
        </tr>
      </thead>
      <tbody>
        {parameters.map((parameter) => (
          <tr key={parameter.ID}>
            <td className="text-nowrap">
              <Link to={`/parameters/${parameter.LINKED_CODE}`}>
                {parameter.LINKED_CODE}
              </Link>
            </td>
            <td>{parameter.LABEL}</td>
            <td>
              <span className="badge badge-success">{parameter.TYPE}</span>
            </td>
            <td>{moment(parameter.LAST_UPDATED_DTS).fromNow()}</td>
            <td>{parameter.LAST_UPDATED_BY}</td>
            <td>
              <Bin size="sm" onClick={() => handleDelete(parameter)} />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default LinkedTable;
